<app-layout>
    <h1 class="mb-8 font-bold text-3xl">Articles</h1>
    <div class="mb-6 flex justify-between items-center">
        <search-filter v-model="form.search" class="w-full max-w-md mr-4 focus:outline-none" @reset="reset">
            <label class="block text-gray-700">Trashed:</label>
            <select v-model="form.trashed" class="mt-1 w-full form-select rounded">
                <option :value="null" />
                <option value="with">With Trashed</option>
                <option value="only">Only Trashed</option>
            </select>
        </search-filter>
        <nav-button-link :href="route('admin.articles.create')">
            <span>Add</span>
            <span class="hidden md:inline">&nbsp;new article</span>
        </nav-button-link>
    </div>
    <div class="bg-white rounded shadow overflow-x-auto">
        <table class="w-full whitespace-no-wrap">
            <tr class="text-left font-bold">
                <th class="px-6 pt-6 pb-4">Title</th>
                <th class="px-6 pt-6 pb-4">Status</th>
            </tr>
            <tr v-for="article in articles.data" :key="article.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                <td class="border-t">
                    <inertia-link :href="route('admin.articles.edit', article.id)" class="px-6 py-4 flex items-center text-indigo-500">
                        {{ article.title }}
                    </inertia-link>
                </td>
                <td class="border-t">
                    <span class="px-6 py-4 flex items-center focus:text-indigo-500">

                        <badge class="mr-2" v-if="article.deleted_at" type="red">
                            {{ 'Trashed' }}
                        </badge>

                        <badge class="mr-2" v-if="!article.deleted_at" :type="article.status ? 'green' : 'gray'">
                            {{ article.status ? 'Active' : 'Hidden' }}
                        </badge>
                    </span>
                </td>
            </tr>
            <tr v-if="articles.data.length === 0">
                <td class="border-t px-6 py-2" colspan="100">No articles found.</td>
            </tr>
        </table>
    </div>
    <pagination :links="articles.links" />
</app-layout>
